import { render } from "./PCUltimosPalesVolcados.vue?vue&type=template&id=68a08166"
import script from "./PCUltimosPalesVolcados.vue?vue&type=script&lang=js"
export * from "./PCUltimosPalesVolcados.vue?vue&type=script&lang=js"

import "./PCUltimosPalesVolcados.vue?vue&type=style&index=0&id=68a08166&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__